import React from 'react';

import Input from '../../../components/Input';

function SingleSelectFilter({question, filter, onChange, validations}) {
  return (
    <Input
      type="select"
      value={filter.values[0] || ''}
      onChange={e => onChange({...filter, values: e.target.value === '' ? [] : [e.target.value]})}
      invalid={validations.length > 0}
      validationText={validations[0]}>
      <option value="">Choose an option...</option>
      {[...question.questionOptions].sort((a, b) => a.order - b.order).map(option => (
        <option key={option.value} value={option.value}>{option.value}</option>
      ))}
    </Input>
  );
}

SingleSelectFilter.validate = filter => {
  if (!filter.values[0]) {
    return ['Please choose an option'];
  }

  return [];
};

SingleSelectFilter.operators = [
  'EQUAL',
  'NOT_EQUAL'
];

export default SingleSelectFilter;